import React, { useEffect, useState } from 'react';
import { Mail, Lock, Eye, EyeOff, HeartPulse } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Login.css'; // mantido: outras telas ainda usam regras globais deste arquivo
import './LoginNovo.css';

const CHAVE_EMAIL = 'login_email_lembrado';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [lembrar, setLembrar] = useState(false);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  // Preenche o e-mail salvo (só o e-mail, nunca a senha).
  useEffect(() => {
    try {
      const salvo = localStorage.getItem(CHAVE_EMAIL);
      if (salvo) {
        setEmail(salvo);
        setLembrar(true);
      }
    } catch (e) {
      /* sem acesso ao armazenamento do navegador: ignora */
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      try {
        if (lembrar) localStorage.setItem(CHAVE_EMAIL, email);
        else localStorage.removeItem(CHAVE_EMAIL);
      } catch (e2) {
        /* ignora */
      }
      navigate('/');
    } catch (err) {
      setError(err.message || 'Erro ao fazer login. Verifique suas credenciais.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lg-page">
      <div className="lg-card">
        <div className="lg-header">
          <div className="lg-icone"><HeartPulse size={32} /></div>
          <h1 className="lg-titulo">Bem-vindo de volta</h1>
          <p className="lg-sub">Entre com sua conta para continuar</p>
        </div>

        <form className="lg-form" onSubmit={handleSubmit}>
          <div>
            <label className="lg-label" htmlFor="lg-email">E-mail</label>
            <div className="lg-campo">
              <span className="lg-campo-icone"><Mail size={20} /></span>
              <input
                id="lg-email"
                className="lg-input"
                type="email"
                autoComplete="username"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div>
            <label className="lg-label" htmlFor="lg-senha">Senha</label>
            <div className="lg-campo">
              <span className="lg-campo-icone"><Lock size={20} /></span>
              <input
                id="lg-senha"
                className="lg-input lg-input-senha"
                type={mostrarSenha ? 'text' : 'password'}
                autoComplete="current-password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="lg-eye"
                aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                onClick={() => setMostrarSenha(!mostrarSenha)}
              >
                {mostrarSenha ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          <div className="lg-opcoes">
            <label className="lg-lembrar">
              <input type="checkbox" checked={lembrar} onChange={(e) => setLembrar(e.target.checked)} />
              <span>Lembrar-me</span>
            </label>
          </div>

          {error && (
            <div className="lg-erro" role="alert">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
              <span>{error}</span>
            </div>
          )}

          <button type="submit" className="lg-submit" disabled={loading}>
            {loading ? (<><span className="lg-spinner" /> Entrando...</>) : 'Entrar'}
          </button>
        </form>

        <div className="lg-rodape">
          <p>Cartão da Família Soulidari · Sistema de Gestão</p>
          <p>© {new Date().getFullYear()} Soulidari. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  );
}
